// Carrier registry — shared by UI dropdowns and the AfterShip integration.
// `code` matches AfterShip slugs (https://www.aftership.com/couriers/all).
export type Carrier = { code: string; name: string };

export const CARRIERS: Carrier[] = [
  { code: "canada-post", name: "Canada Post" },
  { code: "usps", name: "USPS" },
  { code: "ups", name: "UPS" },
  { code: "fedex", name: "FedEx" },
  { code: "dhl", name: "DHL" },
  { code: "purolator", name: "Purolator" },
  { code: "chitchats", name: "ChitChats" },
  { code: "sendle", name: "Sendle" },
  { code: "australia-post", name: "Australia Post" },
  { code: "royal-mail", name: "Royal Mail" },
  { code: "other", name: "Other" },
];

export const CARRIER_MAP: Record<string, string> = Object.fromEntries(
  CARRIERS.map((c) => [c.code, c.name]),
);

export function carrierTrackingUrl(code: string, tracking: string, fallback?: string | null): string {
  switch (code) {
    case "canada-post": return `https://www.canadapost-postescanada.ca/track-reperage/en#/details/${tracking}`;
    case "usps": return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}`;
    case "ups": return `https://www.ups.com/track?tracknum=${tracking}`;
    case "fedex": return `https://www.fedex.com/fedextrack/?trknbr=${tracking}`;
    case "dhl": return `https://www.dhl.com/en/express/tracking.html?AWB=${tracking}`;
    case "purolator": return `https://www.purolator.com/en/shipping/tracker?pin=${tracking}`;
    case "chitchats": return `https://chitchats.com/tracking/${tracking}`;
    case "sendle": return `https://track.sendle.com/tracking?ref=${tracking}`;
    case "australia-post": return `https://auspost.com.au/mypost/track/#/details/${tracking}`;
    case "royal-mail": return `https://www.royalmail.com/track-your-item#/tracking-results/${tracking}`;
    default: return fallback || "#";
  }
}
